export * from './feld-detail.component';
export * from './feld-detail.component.module';